import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';

import Styled from 'styled';

import { GroupNavigationFragment } from './group-navigation.graphql';
import { MemberRole } from './group-navigation.graphql.types';

import defaultStyles from 'four-nets/photoblog/feed/feed-filter/feed-filter.scss';

interface Props extends GroupNavigationFragment {
    styles: typeof defaultStyles;
}

class FeedFilter extends React.Component<Props> {
    render() {
        const { id, isJoinedByViewer, viewerMemberRole, postsCount, imagesCount, styles } = this.props;

        return (
            <div className={styles.container}>
                <NavLink
                    to={isJoinedByViewer ? `/group/${id}/` : '#'}
                    exact
                    className={classnames(styles.button, { [styles.disabled]: !isJoinedByViewer })}
                    activeClassName={styles.active}
                >
                    <FormattedMessage id='GROUP_POSTS' />
                    <span className={styles.count}>{postsCount}</span>
                </NavLink>
                <NavLink
                    to={isJoinedByViewer ? `/group/${id}/photos/` : '#'}
                    className={classnames(styles.button, { [styles.disabled]: !isJoinedByViewer })}
                    activeClassName={styles.active}
                >
                    <FormattedMessage id='GROUP_PHOTOS' />
                    <span className={styles.count}>{imagesCount}</span>
                </NavLink>
                <NavLink to={`/group/${id}/detail/`} className={styles.button} activeClassName={styles.active}>
                    <FormattedMessage id='GROUP_INFO' />
                </NavLink>
                {viewerMemberRole === MemberRole.MEMBER_ROLE_MODERATOR ||
                viewerMemberRole === MemberRole.MEMBER_ROLE_CREATOR ? (
                    <NavLink to={`/group/${id}/settings/`} className={styles.button} activeClassName={styles.active}>
                        <FormattedMessage id='GROUP_SETTINGS' />
                    </NavLink>
                ) : null}
            </div>
        );
    }
}

export default Styled(defaultStyles)(FeedFilter);
